const emailRegex = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export const isEmail = (str = '') => emailRegex.test(str);
